// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_nw-0";
export var buttonContainer = "_nw-3";
export var cancelButton = "_nw-4";
export var headerSection = "_nw-6";
export var headerTitle = "_nw-9";
export var messageSideLeft = "_nw-1";
export var messageSideRight = "_nw-2";
export var orderNumberContainer = "_nw-7";
export var orderNumberLabel = "_nw-8";
export var submitButton = "_nw-5";